export const DollarCheckIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M14.6646 6.66488V9.9979C14.6646 13.3309 13.3314 14.6641 9.99839 14.6641H5.99876C2.66573 14.6641 1.33252 13.3309 1.33252 9.9979V5.99827C1.33252 2.66524 2.66573 1.33203 5.99876 1.33203H9.33179"
      stroke={strokeColor}
      strokeWidth="1.03981"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6644 6.66536H11.9977C9.99772 6.66536 9.33105 5.9987 9.33105 3.9987V1.33203L11.9977 3.9987L14.6644 6.66536Z"
      stroke={strokeColor}
      strokeWidth="1.03981"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.77212 9.26451L6.77192 9.26444L4.40713 8.42296L4.40713 8.42295L4.40503 8.42222C4.20414 8.35199 4.0097 8.25478 3.86389 8.09014C3.72587 7.93431 3.59915 7.68152 3.59915 7.2353C3.59915 6.5283 4.14509 5.98782 4.7777 5.98782H6.25056C6.97477 5.98782 7.59342 6.60887 7.59342 7.41308C7.59342 7.42333 7.58936 7.4349 7.57934 7.44501C7.56936 7.45509 7.55971 7.45759 7.55325 7.45759C7.5468 7.45759 7.53714 7.45509 7.52716 7.44501C7.51715 7.4349 7.51308 7.42333 7.51308 7.41308C7.51308 6.70825 6.97708 6.07685 6.25056 6.07685H4.7777C4.14507 6.07685 3.67949 6.63123 3.67949 7.2353C3.67949 7.53078 3.72979 7.79411 3.89625 8.00089C4.05724 8.20088 4.27934 8.28259 4.42632 8.33498L4.42651 8.33505L6.79131 9.17653L6.7913 9.17653L6.79341 9.17727C6.9943 9.24749 7.18873 9.34471 7.33455 9.50934C7.47243 9.66503 7.59905 9.91747 7.59929 10.3629C7.59406 11.0687 7.04979 11.6117 6.42073 11.6117H4.94787C4.22367 11.6117 3.60501 10.9906 3.60501 10.1864C3.60501 10.1762 3.60908 10.1646 3.61909 10.1545C3.62907 10.1444 3.63873 10.1419 3.64518 10.1419C3.65164 10.1419 3.6613 10.1444 3.67128 10.1545C3.68129 10.1646 3.68535 10.1762 3.68535 10.1864C3.68535 10.8912 4.22136 11.5226 4.94787 11.5226H6.42073C7.05337 11.5226 7.51895 10.9683 7.51895 10.3642C7.51895 10.0687 7.46865 9.80537 7.30219 9.59859C7.1412 9.3986 6.9191 9.3169 6.77212 9.26451Z"
      fill={strokeColor}
      stroke={strokeColor}
      strokeWidth="0.799855"
    />
    <path
      d="M5.59872 12.3977C5.59229 12.3977 5.58265 12.3952 5.57268 12.3851C5.56267 12.375 5.55862 12.3635 5.55862 12.3532V5.2432C5.55862 5.23297 5.56267 5.22142 5.57268 5.21132C5.58265 5.20125 5.59229 5.19876 5.59872 5.19876C5.60516 5.19876 5.6148 5.20125 5.62477 5.21132C5.63477 5.22142 5.63883 5.23297 5.63883 5.2432V12.3532C5.63883 12.3635 5.63477 12.375 5.62477 12.3851C5.6148 12.3952 5.60516 12.3977 5.59872 12.3977Z"
      fill={strokeColor}
      stroke={strokeColor}
      strokeWidth="0.799855"
    />
  </svg>
);
